import { Form } from '@/components/forms/form';
import { getYupSchemaForPassword } from '@/components/forms/password-input/checks/utils';
import { PasswordSection } from '@/components/forms/password-input/component';
import { FormikProps } from 'formik';

const validationSchema = getYupSchemaForPassword('password', 'reenterPassword');

export type ChangePasswordFormValues = {
	password: string;
	reenterPassword: string;
};

const initialValues = {
	password: '',
	reenterPassword: '',
};

type ChangePasswordFormProps = {
	onSubmit: (values: ChangePasswordFormValues) => void;
	formRef: React.RefObject<FormikProps<ChangePasswordFormValues>>;
};

export const ChangePasswordForm = ({ onSubmit, formRef }: ChangePasswordFormProps) => {
	return (
		<Form
			initialValues={initialValues}
			onSubmit={onSubmit}
			innerRef={formRef}
			validationSchema={validationSchema}
		>
			{({ getFieldProps, errors, touched }) => (
				<PasswordSection
					passwordProps={{
						label: 'Password',
						placeholder: '******',
						...getFieldProps('password'),
						error: touched.password && errors.password,
					}}
					reenterPasswordProps={{
						label: 'Re-enter Password',
						placeholder: '******',
						...getFieldProps('reenterPassword'),
						error: touched.reenterPassword && errors.reenterPassword,
					}}
				/>
			)}
		</Form>
	);
};
